import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Dashboard from './layouts/dashboard'
import Default from './layouts/default'
import Main from './layouts/main'
import Plan from './layouts/plan'
import Setting from './layouts/setting'
import Customerdashboard from './layouts/customerdashboard'
import Customer from './layouts/customer'
import Vuelidate from 'vuelidate'
import i18n from './i18n'
import VueConfirmDialog from 'vue-confirm-dialog'
import datePicker from 'vue-bootstrap-datetimepicker'
import VueBootstrapDatetimePicker from 'vue-bootstrap-datetimepicker'

import ConfigPlugin from './plugins/config'


// import axios from './utils/axiosinstance';
import axios from 'axios';

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/css/datepicker.css'
// import '@/assets/vendor/font-awesome-4.7/css/font-awesome.min.css'
// import '@/assets/vendor/fontawesome-6.2.0/css/all.css'
import '@/assets/vendor/fontawesome-6.6.0/css/all.css'
import '@/assets/vendor/mdi-font/css/material-design-iconic-font.min.css'
import '@/assets/css/main.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import '@/assets/css/style1.css'
import '@/assets/js/bootstrap-datepicker.js'
import '@/assets/css/photo_canvas_preview.css'
import '@/mixins/globalMethods'
import 'ion-rangeslider'
import '@/assets/css/ioslider.css'

import Toast from 'vue-toastification'
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css'
import moment from 'moment'



Vue.prototype.moment = moment

Vue.use(VueConfirmDialog)
Vue.use(datePicker)
// Vue.use(select2)

Vue.component('date-picker', VueBootstrapDatetimePicker);

$.extend(true, $.fn.datetimepicker.defaults, {
  icons: {
    time: 'fa fa-clock',
    date: 'fa fa-calendar',
    up: 'fa fa-arrow-up',
    down: 'fa fa-arrow-down',
    previous: 'fa fa-chevron-left',
    next: 'fa fa-chevron-right',
    today: 'fa fa-calendar-check',
    clear: 'fa fa-trash-alt',
    close: 'fa fa-times-circle'
  }
});
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
// Vue.component('datetime', datetime)
Vue.directive('visible', (el, binding) => {
  el.style.visibility = binding.value ? 'visible' : 'hidden'
})

Vue.config.productionTip = false
Vue.use(Vuelidate)

const options = {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false
}


Vue.use(Toast, options)

window.$ = window.jQuery = require('jquery')

Vue.component('dashboard-layout', Dashboard)
Vue.component('default-layout', Default)
Vue.component('main-layout', Main)
Vue.component('plan-layout', Plan)
Vue.component('setting-layout', Setting)
Vue.component('customerdashboard-layout', Customerdashboard)
Vue.component('customer-layout', Customer)


async function initializeApp() {
  try {
    const response = await axios.get('/config.json');
    const config = response.data;

    // Konfigurationsdaten global verfügbar machen
    Vue.prototype.$config = config;
    Vue.use(ConfigPlugin, config);

    // Setze die Basis-URL für Axios basierend auf der geladenen Config
    if (config.apiBaseUrl) {
      axios.defaults.baseURL = config.apiBaseUrl;
    }

    console.log('Konfigurationsdaten geladen:', config);


    console.log('Config Loaded')

    var vm = new Vue({
      store,
      router,
      components: { App },
      i18n,
      template: '<App/>'
    })
    vm.$mount('#app')

  } catch(error) {
    console.error('Fehler beim laden der Konfiguration.', error)
  }
}

// App initialisieren
initializeApp();

// var vm = new Vue({
//   store,
//   router,
//   components: { App },
//   i18n,
//   template: '<App/>'
// })
// vm.$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js